import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import ProblemList from '../views/problem/problemList.vue'
import Problem from '../views/problem/problem.vue'

import Profile from '../views/profile.vue'
import Login from '../views/login.vue'
import SubmissionList from '../views/submission/submissionList.vue'
import Submission from '../views/submission/submission.vue'
import Admin from '../views/admin/admin.vue'
import UserManagement from '../views/admin/UserManagement.vue'
import EditProblem from '../views/admin/EditProblem.vue'
import EditCheckpoint from '../views/admin/EditCheckpoint.vue'
import EditAttribute from '../views/admin/EditAttribute.vue'
import DebugTools from '../views/admin/EditDebugTool.vue'
import ScoreManagement from '../views/admin/ScoreManagement.vue'

Vue.use(VueRouter)
const title = "SysJudge"
const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: { title: title }
  },
  {
    path: '/problem',
    name: 'Problems',
    component: ProblemList,
    meta: { title: "Problems - " + title }
  },
  {
    path: '/problem/add',
    name: 'AddProblem',
    component: EditProblem,
    meta: { title: "Add Problem - " + title }

  },
  {
    path: '/problem/:id',
    name: 'Problem',
    component: Problem,
    meta: { title: "Problem - " + title },
    props: true,
  },
  {
    path: '/problem/:id/edit',
    name: 'EditProblem',
    component: EditProblem,
    meta: { title: "Edit Problem - " + title },
  },
  {
    path: '/problem/:id/checkpoint',
    name: 'EditCheckpoint',
    component: EditCheckpoint,
    meta: { title: "Edit Checkpoint - " + title },
  },
  {
    path: '/profile',
    name: 'Profile',
    component: Profile,
    meta: { title: "My Profile - " + title },
  },
  {
    path: '/admin',
    name: 'Admin',
    component: Admin
  },
  {
    path: '/admin/user',
    name: 'UserManagement',
    component: UserManagement,
    meta: { title: "User Management - " + title },
  },
  {
    path: '/admin/attribute',
    name: 'Attribute',
    component: EditAttribute,
    meta: { title: "Edit Attribute - " + title },
  },
  {
    path: '/admin/debugtools',
    name: 'DebugTools',
    component: DebugTools,
    meta: { title: "Debug Tool Management - " + title },
  }, {
    path: '/admin/score',
    name: 'ScoreManagemnet',
    component: ScoreManagement,
    meta: { title: "Score Management - " + title },
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/submission',
    name: 'SubmissionList',
    component: SubmissionList,
    meta: { title: "Submissions - " + title },
  },
  {
    path: '/submission/:id',
    name: 'Submission',
    component: Submission,
    meta: { title: "Submissions - " + title },
  },
  //{
  //  path: '/about',
  //  name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
  //  component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  //}
]

const router = new VueRouter({
  routes,
  mode: 'history'
})
router.beforeEach((to, from, next) => {
  window.document.title = to.meta.title;
  next()
})
export default router
